<template>
  <div class="subModal scroll">
    <template v-if="tics.length > 0">
      <div class="item" v-for="t in tics" :key="t.id">
        <div class="title" @click="emits('TickChat', t.id)">{{ t.assunto }}</div>
        <div class="status" :class="t.status"></div>
      </div>
    </template>
    <template v-else>
      <div class="text-center px-4">
        <span class="text-sm">Nenhum ticket aberto.</span>
      </div>
    </template>
  </div>
</template>

<script setup>


import { ref } from 'vue'
import { getMyTickets } from '@/services/api.js'

const emits = defineEmits(['textAlerta', 'TickChat'])

const tics = ref([])

async function getTic() {
  try {
    const data = await getMyTickets()
    tics.value = (data.records ?? []).map(t => ({
      id: t.id,
      assunto: t.subject ?? t.title ?? `Ticket #${t.id}`,
      status: String(t.status ?? ''),
    }))
  } catch (_) {
    emits('textAlerta', 'Erro ao carregar tickets')
    tics.value = []
  }
}

getTic()

</script>

<style scoped>
.scroll {
  overflow: auto;
  position: relative;
  height: 250px;
}

.subModal .item {
  position: relative;
  float: left;
  width: 100%;
  height: 30px;
  padding: 0 10px;
  font-size: 14px;
  line-height: 30px;
  background-color: #EFF2F5;
  border-radius: 12px;
  margin-top: 6px;
}

.subModal .item .status {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background-color: #34A638;
}

.subModal .item .status.false {
  background-color: #D21111;
}

</style>
